module.exports = __webpack_public_path__ + "static/media/pwa.6dc6eeb3.png";